import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

import { format, isBefore, subHours } from "date-fns";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import LiveBase from "@/components/live_video/LiveBase.vue";
import { useStreams } from "@/composables/stream";
import BaseWidget from "@/views/dashboard/componentsV2/BaseWidget.vue";
import DashboardDragHandle from "@/views/dashboard/componentsV2/DashboardDragHandle.vue";
import { useVideoPlayerDimensions } from "@/views/dashboard/composables";
import { liveStreamWidgetHeaderHeight } from "@/views/dashboard/services/projectOverviewV2Layout";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveStreamWidget',
  props: {
    arg: {},
    width: {},
    height: {}
  },
  emits: ["delete"],
  setup(__props: any) {

const props = __props;


const { t } = useI18n();

const { streams } = useStreams();

const stream = computed(() => streams.value.find(({ camera_id }) => camera_id === props.arg));

const containerRef = ref<HTMLDivElement | null>(null);

const playerDimensions = useVideoPlayerDimensions(containerRef);

const routerConnectionLostMessage = computed(() => {
  if (
    stream.value &&
    stream.value.status === "offline" &&
    stream.value.status_updated_at &&
    isBefore(stream.value.status_updated_at, subHours(new Date(), 1))
  ) {
    return `${t("dashboard.project.stream_card.connection_lost", {
      updatedAt: format(stream.value.status_updated_at, "dd.MM.yyyy HH:mm"),
    })}`;
  }

  return null;
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(BaseWidget, {
    onDelete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete'))),
    hideDragHandle: "",
    menuClass: "top-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "h-full flex flex-col",
        ref_key: "containerRef",
        ref: containerRef
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle({ height: `${_unref(liveStreamWidgetHeaderHeight)}px` })
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["pl-4 pr-7 flex items-center py-4 gap-2", {
            'bg-red-100': routerConnectionLostMessage.value,
          }])
          }, [
            _createVNode(DashboardDragHandle, { class: "shrink-0" }),
            (stream.value)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  to: {
              name: 'Live',
              params: {
                camera_id: stream.value.camera_id,
                customer_name: stream.value.customer_name,
                site_id: stream.value.site_id,
              },
            },
                  class: "font-semibold text-gray-900 truncate text-lg hover:text-yellow-800"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(stream.value?.name), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ], 2)
        ], 4),
        _createElementVNode("div", {
          style: _normalizeStyle({ height: `${_unref(playerDimensions).height}px` }),
          class: "bg-oaiGray-900 flex flex-col items-center",
          "data-oai-left-over-space-calculator": "ignore"
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({
            width: `${_unref(playerDimensions).width}px`,
          }),
            class: "overflow-hidden"
          }, [
            _createVNode(LiveBase, {
              cameraId: _ctx.arg,
              noSrcMessage: routerConnectionLostMessage.value,
              addRightSpaceToControlBar: true
            }, null, 8, ["cameraId", "noSrcMessage"])
          ], 4)
        ], 4)
      ], 512)
    ]),
    _: 1
  }))
}
}

})